module.exports = __webpack_public_path__ + "static/media/arrow-down.27d87a5e.svg";